import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

export default function ProductDebug() {
  const [products, setProducts] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const fetchProducts = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      
      const response = await fetch('/api/admin/shopify-products?refresh=true', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setProducts(data);
        console.log('Debug: Fetched', data.length, 'products');
        console.log('First product:', data[0]);
        console.log('Last product:', data[data.length - 1]);
        
        // Look for specific products
        const zincProduct = data.find((p: any) => p.title.includes('Zinc'));
        const vitaminBProduct = data.find((p: any) => p.title.includes('VITAMIN B COMPLEX'));
        
        console.log('Debug: Zinc product found:', !!zincProduct);
        console.log('Debug: Vitamin B product found:', !!vitaminBProduct);
      } else {
        const error = await response.json();
        setErrorMessage(error.message || 'Failed to fetch products');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      setErrorMessage('An error occurred while fetching products');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded bg-gray-50">
      <h2 className="text-lg font-bold mb-4">Product Debug Tool</h2>
      
      <Button 
        variant="outline"
        onClick={fetchProducts}
        disabled={isLoading}
        className="mb-4"
      >
        {isLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
        Fetch Shopify Products
      </Button>
      
      {errorMessage && (
        <div className="text-red-500 mb-4">{errorMessage}</div>
      )}
      
      <div className="mb-4">
        <strong>Total Products: </strong> {products.length}
      </div>
      
      <div className="mb-4">
        <strong>Products List (first 10):</strong>
        <ul className="ml-4 list-disc">
          {products.slice(0, 10).map(product => (
            <li key={product.id}>
              {product.title} (ID: {product.id})
            </li>
          ))}
        </ul>
      </div>
      
      {products.length > 10 && (
        <div className="mb-4">
          <strong>Last 10 products:</strong>
          <ul className="ml-4 list-disc">
            {products.slice(-10).map(product => (
              <li key={product.id}>
                {product.title} (ID: {product.id})
              </li>
            ))}
          </ul>
        </div>
      )}
      
      {products.some(p => p.title.includes('Zinc')) ? (
        <div className="text-green-500">✓ Zinc product found in list</div>
      ) : (
        <div className="text-red-500">✗ Zinc product NOT found in list</div>
      )}
      
      {products.some(p => p.title.includes('VITAMIN B COMPLEX')) ? (
        <div className="text-green-500">✓ Vitamin B Complex product found in list</div>
      ) : (
        <div className="text-red-500">✗ Vitamin B Complex product NOT found in list</div>
      )}
    </div>
  );
}